var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPomegranate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 88,
    viewBox: "0 0 75 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1474_13833)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.4868 3.97949H26.5132V34.3865H48.4868V3.97949Z",
    fill: "#FFFAED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70 18H3V82H70V18Z",
    fill: "#FFFAED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 6H11V83H64V6Z",
    fill: "#FFFAED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.074 16.4395H54.0146V32.9057H66.074V16.4395Z",
    fill: "#EB6262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.3996 21.967H59.1973V39.5997H70.3996V21.967Z",
    fill: "#EB6262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 16H5V33H21V16Z",
    fill: "#EB6262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 18H3V39H16V18Z",
    fill: "#EB6262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3108 38.4739H4.60059V44.0066H10.3108V38.4739Z",
    fill: "#EB6262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.4045 39.0823H64.6943V82.6085H70.4045V39.0823Z",
    fill: "#EB6262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70 66H59V87H70V66Z",
    fill: "#EB6262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70 72H54V83H70V72Z",
    fill: "#EB6262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69 78H48V83H69V78Z",
    fill: "#EB6262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 66H0V83H10V66Z",
    fill: "#EB6262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 72H3V83H16V72Z",
    fill: "#EB6262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 77H3V83H21V77Z",
    fill: "#EB6262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6951 21.967H31.9849V27.373H37.6951V21.967Z",
    fill: "#EB6262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0142 21.967H42.9995V27.373H54.0142V21.967Z",
    fill: "#EB6262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 22H0V84H5V22Z",
    fill: "#E03E4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75 22H69V83H75V22Z",
    fill: "#E03E4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.4047 82.6035H4.60059V88.0094H70.4047V82.6035Z",
    fill: "#E03E4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5635 5.33838H47.5488V10.9877H58.5635V5.33838Z",
    fill: "#E03E4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.294 5.46533H16.2793V10.8712H27.294V5.46533Z",
    fill: "#E03E4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 5H11V11H20V5Z",
    fill: "#E03E4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8867 10.8662H7.37939V16.4395H12.8867V10.8662Z",
    fill: "#E03E4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 16H3V22H8V16Z",
    fill: "#E03E4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 5H55V11H64V5Z",
    fill: "#E03E4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.874 10.9878H62.3667V16.4394H67.874V10.9878Z",
    fill: "#E03E4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.5811 16.4597H66.0737V21.9671H71.5811V16.4597Z",
    fill: "#E03E4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59 0H16V6H59V0Z",
    fill: "#E03E4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7426 48.1548H17.0503V50.8577H30.7426V48.1548Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.8275 48.1548H39.1353V50.8577H52.8275V48.1548Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6864 55.5994H27.9941V58.3023H41.6864V55.5994Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3213 54.1438H16.8169V56.8468H25.3213V54.1438Z",
    fill: "#F4A688"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0967 54.1438H44.5923V56.8468H53.0967V54.1438Z",
    fill: "#F4A688"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9848 21.967H21.2744V27.373H31.9848V21.967Z",
    fill: "#FEF1D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9998 21.967H37.6953V27.373H42.9998V21.967Z",
    fill: "#FEF1D5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1474_13833"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 88,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPomegranate);
export default __webpack_public_path__ + "static/media/Pomegranate.da562046a22264e48106bf7dcf307c42.svg";
export { ForwardRef as ReactComponent };